<template>
  <div class="mall-purchase-layer">
    <!-- 상품 구매 -->
    <MallProductPurchaseSheet
      v-if="product"
      :key="product.id"
      :product="product"
      :profileId="profileId"
      @close="$emit('close')"
      @add-cart="addToCart"
      @buy="buyNow"
      @max-reached="showMaxCountToast"
    />

    <!-- 장바구니에 다른 종류의 상품을 담으려고 할 때 -->
    <MallConfirmPopup
      v-if="isCartCategoryPopup"
      :title="'장바구니에는 같은 종류의 상품만\n담을 수 있어요'"
      :messageLines="['다른 종류를 구매하시려면 장바구니를', '먼저 비우거나 결제 후 담아주세요.']"
      :cancelLabel="'닫기'"
      :confirmLabel="'장바구니 확인'"
      @close="isCartCategoryPopup = false"
      @cancel="isCartCategoryPopup = false"
      @confirm="goCart"
    >
      <MallBasketIcon slot="icon" :size="80" />
    </MallConfirmPopup>

    <!-- 구매 시트 위에 보이도록 감쌈 -->
    <div class="mall-purchase-layer__toast">
      <MallToast
        v-if="toast"
        :key="toast.key"
        :title="toast.title"
        :message="toast.message"
        :type="toast.type"
        @close="toast = null"
      />
    </div>
  </div>
</template>

<script>
import Constant from '@/constant'
import mall from '@/utilities/mall.js'
import MallBasketIcon from '@/components/new/atoms/MallBasketIcon.vue'
import MallConfirmPopup from '@/components/new/molecules/MallConfirmPopup.vue'
import MallToast from '@/components/new/molecules/MallToast.vue'
import MallProductPurchaseSheet from '@/components/new/organisms/MallProductPurchaseSheet.vue'

// 상품 구매 시트 + 장바구니 담기(같은 종류만) / 바로 구매하기
export default {
  name: 'MallPurchaseLayer',
  components: {
    MallBasketIcon,
    MallConfirmPopup,
    MallToast,
    MallProductPurchaseSheet,
  },
  props: {
    // 구매할 상품 (mall.toProductView 형태, null이면 시트 닫힘)
    product: {
      type: Object,
      default: null,
    },
    profileId: {
      type: Number,
      default: null,
    },
    // 전체 상품 (key: 상품 id, 값: API 상품) - 장바구니에 담긴 상품의 종류를 찾는 데 사용
    productMap: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isCartCategoryPopup: false,
      isRequesting: false,
      toast: null,
    }
  },
  methods: {
    addToCart(quantity) {
      if (this.isRequesting) return
      var token = mall.getAccessToken()
      if (!token) {
        mall.goLogin(this.$router)
        return
      }
      this.isRequesting = true
      this.$store.dispatch(Constant.FETCH_CART, { profile_id: this.profileId, token: token })
        .then((cart) => {
          var items = (cart && cart.items) || []
          // 다른 종류의 상품이 이미 담겨 있으면 안내 팝업 (구매 시트는 유지)
          var cartProduct = items.length > 0 ? this.productMap[items[0].product_id] : null
          if (cartProduct && cartProduct.category_id !== this.product.category) {
            this.isCartCategoryPopup = true
            return null
          }
          // 전체 교체 API라 기존 목록에 합쳐서 보냄 (같은 상품이면 수량 합산)
          var merged = items.map((item) => ({ product_id: item.product_id, quantity: item.quantity }))
          var same = merged.find((item) => item.product_id === this.product.id)
          if (same) {
            same.quantity += quantity
          } else {
            merged.push({ product_id: this.product.id, quantity: quantity })
          }
          return this.$store.dispatch(Constant.UPDATE_CART_ITEMS, { profile_id: this.profileId, items: merged, token: token })
            .then(() => {
              this.$emit('cart-added', this.product.category)
              this.$emit('close')
              this.toast = { key: Date.now(), title: '장바구니에 담았어요.', type: 'success' }
            })
        })
        .catch((err) => this.handleError(err))
        .then(() => {
          this.isRequesting = false
        })
    },
    buyNow(quantity) {
      if (this.isRequesting) return
      var token = mall.getAccessToken()
      if (!token) {
        mall.goLogin(this.$router)
        return
      }
      // 판매 API는 장바구니를 거쳐야 결제할 수 있어 장바구니를 이 상품으로 바꿈
      // TODO: 기존 장바구니가 사라짐 - 바로 구매 방식 서버와 확인
      this.isRequesting = true
      this.$store.dispatch(Constant.UPDATE_CART_ITEMS, {
        profile_id: this.profileId,
        items: [{ product_id: this.product.id, quantity: quantity }],
        token: token,
      })
        .then(() => {
          // 처방전 제출 화면을 거쳐 구매하기 화면으로 이동
          this.$router.push({ path: '/mall/prescription', query: { profileId: this.profileId } })
        })
        .catch((err) => this.handleError(err))
        .then(() => {
          this.isRequesting = false
        })
    },
    handleError(err) {
      if (mall.isAuthError(err)) {
        mall.goLogin(this.$router)
        return
      }
      this.toast = { key: Date.now(), title: '장바구니에 담지 못했어요.', message: mall.errorMessage(err) }
    },
    goCart() {
      this.$router.push({ path: '/mall/cart', query: { profileId: this.profileId } })
    },
    showMaxCountToast(maxCount) {
      this.toast = { key: Date.now(), title: mall.maxCountMessage(maxCount) }
    },
  },
}
</script>

<style scoped>
.mall-purchase-layer__toast {
  position: relative;
  z-index: 1100;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallPurchaseLayer.vue